import React from 'react'

const CourseRating = ({ value}) => {
     // Round to nearest 0.5
  const roundedValue = Math.round(value * 2) / 2;
  return (
        <div className="flex space-x-1 mt-2">
      {[1, 2, 3, 4, 5].map((star) => {
        if (roundedValue >= star) {
          // Full star
          return (
            <svg key={star} className="w-5 h-5 text-[#FFB326]" fill="currentColor" viewBox="0 0 20 20">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.182 3.64a1 1 0 00.95.69h3.825c.969 0 1.371 1.24.588 1.81l-3.096 2.25a1 1 0 00-.364 1.118l1.182 3.64c.3.921-.755 1.688-1.538 1.118l-3.096-2.25a1 1 0 00-1.176 0l-3.096 2.25c-.783.57-1.838-.197-1.538-1.118l1.182-3.64a1 1 0 00-.364-1.118L2.506 9.067c-.783-.57-.38-1.81.588-1.81h3.825a1 1 0 00.95-.69l1.182-3.64z" />
            </svg>
          );
        } else if (roundedValue + 0.5 === star) {
          // Half star
          return (
            <svg key={star} className="w-5 h-5 text-[#FFB326]" viewBox="0 0 20 20" fill="currentColor">
              <defs>
                <linearGradient id={`half${star}`}>
                  <stop offset="50%" stopColor="currentColor" />
                  <stop offset="50%" stopColor="transparent" stopOpacity="1" />
                </linearGradient>
              </defs>
              <path fill={`url(#half${star})`} d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.182 3.64a1 1 0 00.95.69h3.825c.969 0 1.371 1.24.588 1.81l-3.096 2.25a1 1 0 00-.364 1.118l1.182 3.64c.3.921-.755 1.688-1.538 1.118l-3.096-2.25a1 1 0 00-1.176 0l-3.096 2.25c-.783.57-1.838-.197-1.538-1.118l1.182-3.64a1 1 0 00-.364-1.118L2.506 9.067c-.783-.57-.38-1.81.588-1.81h3.825a1 1 0 00.95-.69l1.182-3.64z" />
            </svg>
          );
        } else {
          // Empty star
          return (
            <svg key={star} className="w-5 h-5 text-gray-300" fill="currentColor" viewBox="0 0 20 20">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.182 3.64a1 1 0 00.95.69h3.825c.969 0 1.371 1.24.588 1.81l-3.096 2.25a1 1 0 00-.364 1.118l1.182 3.64c.3.921-.755 1.688-1.538 1.118l-3.096-2.25a1 1 0 00-1.176 0l-3.096 2.25c-.783.57-1.838-.197-1.538-1.118l1.182-3.64a1 1 0 00-.364-1.118L2.506 9.067c-.783-.57-.38-1.81.588-1.81h3.825a1 1 0 00.95-.69l1.182-3.64z" />
            </svg>
          );
        }
      })}
      <span className='text-gray-500'>(2000)</span>
    </div>
  )
}

export default CourseRating